// extracted by mini-css-extract-plugin
export default {"heading":"CalenderBookingArea_heading__t5mEw"};